var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuycall1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 38.5H7V43H36L60.5 18L55.5 16.5L33.5 38.5Z",
    fill: "#E94C69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 38.4998V37.9998H6.5V38.4998H7ZM33.5 38.4998V38.9998C33.6326 38.9998 33.7598 38.9471 33.8536 38.8534L33.5 38.4998ZM55.5 16.4998L55.6437 16.0209L55.3576 15.9351L55.1464 16.1462L55.5 16.4998ZM60.5 17.9998L60.8571 18.3498L61.4364 17.7587L60.6437 17.5209L60.5 17.9998ZM36 42.9998V43.4998C36.1344 43.4998 36.2631 43.4457 36.3571 43.3498L36 42.9998ZM7 42.9998H6.5V43.4998H7V42.9998ZM7 38.9998H33.5V37.9998H7V38.9998ZM33.8536 38.8534L55.8536 16.8534L55.1464 16.1462L33.1464 38.1462L33.8536 38.8534ZM55.3563 16.9787L60.3563 18.4787L60.6437 17.5209L55.6437 16.0209L55.3563 16.9787ZM60.1429 17.6498L35.6429 42.6498L36.3571 43.3498L60.8571 18.3498L60.1429 17.6498ZM36 42.4998H7V43.4998H36V42.4998ZM7.5 42.9998V38.4998H6.5V42.9998H7.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18V11.5L37.5 34.5H44L60 18Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuycall1);
export default __webpack_public_path__ + "static/media/buy call1.32c85329a8673dd68e09bef2807ea12a.svg";
export { ForwardRef as ReactComponent };